module.exports = __webpack_public_path__ + "img/微信图片_20211224150151.bf349976.png";